import React from 'react';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from '@mui/material';

export const COLUMN_OPTIONS = [2, 4, 6, 8, 10, 12];

export interface MockupViewControlsProps {
    columns: number;
    onColumns: (columns: number) => void;
    showTags?: boolean;
    onShowTags?: (show: boolean) => void;
    groupByCustomer?: boolean;
    onGroupByCustomer?: (group: boolean) => void;
    disabled?: boolean;
}

/** How the preview grid is laid out (columns, tags, grouping); these never touch the request. */
const MockupViewControls = ({ columns, onColumns, showTags, onShowTags, groupByCustomer, onGroupByCustomer, disabled = false }: MockupViewControlsProps) => (
    <>
        <FormControl size="small" sx={{ width: 104 }}>
            <InputLabel id="mockup-columns-label">Columns</InputLabel>
            <Select
                labelId="mockup-columns-label"
                label="Columns"
                value={columns}
                onChange={(event) => onColumns(Number(event.target.value))}
                disabled={disabled}
            >
                {COLUMN_OPTIONS.map((value) => (
                    <MenuItem key={value} value={value}>{value}</MenuItem>
                ))}
            </Select>
        </FormControl>
        {onShowTags && (
            <FormControlLabel
                sx={{ m: 0, mr: 0.5 }}
                control={<Switch size="small" checked={!!showTags} onChange={(event) => onShowTags(event.target.checked)} />}
                label="Tags"
            />
        )}
        {onGroupByCustomer && (
            <FormControlLabel
                sx={{ m: 0 }}
                control={<Switch size="small" checked={!!groupByCustomer} onChange={(event) => onGroupByCustomer(event.target.checked)} />}
                label="Group by customer"
            />
        )}
    </>
);

export default MockupViewControls;
